
import { PropType, computed, defineComponent } from 'vue'

export default defineComponent({
    props: {
        unit: {
            type: String,
            default: null,
        },
        oldValues: {
            type: Array as PropType<Array<string | number | null>>,
            default: null,
        },
        currentValue: {
            type: [String, Number, null] as PropType<string | number | null>,
            default: null,
        },
    },
    setup(props) {
        const isRenderingOldValue = computed(() => {
            if (props.oldValues.length > 0) {
                return true
            }

            return false
        })

        const isRenderingUnit = computed(() => {
            if (props.unit) {
                return true
            }

            return false
        })

        const isRenderingCurrentValue = computed(() => {
            if (props.currentValue !== null) {
                return true
            }

            return false
        })

        return {
            isRenderingOldValue,
            isRenderingUnit,
            isRenderingCurrentValue,
        }
    },
})
